"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Identity_1 = require("../identity/Identity");
var UI_1 = require("../ui/UI");
function Wrapper(_a) {
    var RouterComponent = _a.RouterComponent, children = _a.children, identity = _a.identity, ui = _a.ui;
    var wrapped = react_1.default.createElement(RouterComponent, { children: children });
    if (identity) {
        wrapped = react_1.default.createElement(Identity_1.IdentityContextProvider, tslib_1.__assign({}, identity), wrapped);
    }
    wrapped = react_1.default.createElement(UI_1.UIContextProvider, tslib_1.__assign({}, ui), wrapped);
    return react_1.default.createElement(react_1.StrictMode, null, wrapped);
}
exports.Wrapper = Wrapper;
//# sourceMappingURL=Wrapper.js.map